import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// import { Media } from "react-bootstrap";
// import DataTable from "react-data-table-component";
// import DataTableExtensions from "react-data-table-component-extensions";

// import { useMaterialReactTable } from 'material-react-table/hooks';
import {MaterialReactTable} from 'material-react-table';
import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken  } from "../Global";
// import SubRowComponent from './SubRowComponent'; // Import the SubRowComponent
import PropTypes from 'prop-types';

// import {
//   MaterialReactTable,
//   useMaterialReactTable,
// } from 'material-react-table';
// import Swal from 'sweetalert2';
// import {
//   Box,
//   Button,
//   ListItemIcon,
//   MenuItem,
//   Typography,
//   TextField,
// } from '@mui/material';
// import { AccountCircle, Send } from '@mui/icons-material';
// //import Button from '@mui/material/Button';
// import ButtonGroup from '@mui/material/ButtonGroup';
// import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
// import ClickAwayListener from '@mui/material/ClickAwayListener';
// import Grow from '@mui/material/Grow';
// import Paper from '@mui/material/Paper';
// import Popper from '@mui/material/Popper';
// //import MenuItem from '@mui/material/MenuItem';
// import MenuList from '@mui/material/MenuList';
// import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Products = () => {
  const [menu, setMenu] = useState(false);
  // const [data, setData] = useState([]);
  const [permission, setPermission] = useState({});

  const [dataa, setDataa] = useState([]);

  
  useEffect(() => {
        setPermission(FindModuleById(5)); 
console.log(permission);

  
    axios
      .post(
        "/products/listing-groupby",
        {},
        {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          setDataa(response.data.data.products);
        }
        else  if (response.data.code === 401) {
          window.location.href = "/login";
        }else{
          window.location.href = "/login"; 
        }
        
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

 
 
  
  
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
 // ✅ Define PropTypes for FullNameCell
//  FullNameCell.propTypes = {
//    renderedCellValue: PropTypes.string.isRequired,
//    row: PropTypes.shape({
//      original: PropTypes.shape({
//        profile_picture: PropTypes.string,
//        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
//      }).isRequired,
//    }).isRequired,
//  };
 
 // ✅ Functional component for Details Cell
 const DetailsCell = ({  row }) => {
   return <a href={`/products-groupby-name/${row.original.name}`}>{row.original.name}</a>;
 };
 // ✅ Define PropTypes for DetailsCell
 DetailsCell.propTypes = {
   renderedCellValue: PropTypes.string.isRequired,
   row: PropTypes.shape({
     original: PropTypes.shape({
       id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
       name: PropTypes.string.isRequired, // ✅ Add this line

     }).isRequired,
   }).isRequired,
 };
  const columns2 =
  [
   
    // {
    //   header: 'Product Name',
    //   accessorFn: (row) => `${row.name}`,
    //   Cell: ({  row }) => {        
     
    //         return(
    //           <a href={'/products-groupby-name/'+row.original.name} className=""  >
    //              {row.original.name}
    //           </a>
              
    //         )
    //   },
  
    // },
    {
      header: 'Details',
      accessorFn: (row) => `${row.name}`,
      Cell: DetailsCell, // ✅ Assigning function directly (No inline)
    },
    {
      header: 'Number of Sub products',
      accessorFn: (row) => `${(row.total_products)?row.total_products:0} `,
    }
   ];

    
  //  const columns = [
  //   { header: 'ID', accessorKey: 'id' },
  //   { header: 'Name', accessorKey: 'name' },
  //   // { header: 'Description', accessorKey: 'description' },
    
  //   {
  //     header: 'Number of Sub products',
  //     accessorFn: (row) => `${(row.subRows)?row.subRows.length:0} `,
  //   },
  //   // { header: 'Type', accessorKey: 'type' },
  //   // { header: 'Category', accessorKey: 'category' },
  //   // { header: 'Created By', accessorKey: 'createdby' },
  //   // { header: 'Updated By', accessorKey: 'updatedby' },
  // ];

  //const data = [{"id":1,"name":"Avocado","description":null,"type":"Organic","category":"Hass","createdby":"Elmehdi Elmehdi","updatedby":"","subRows":[{"id":1,"name":"Avocado","description":null,"type":"Organic","category":"Hass","createdby":"Elmehdi Ouachmi","updatedby":""},{"id":2,"name":"Avocado","description":null,"type":"Conventional","category":"Hass","createdby":"Elmehdi Ouachmi","updatedby":"Elmehdi Ouachmi"},{"id":3,"name":"Avocado","description":null,"type":"Conventional","category":"Lamb hass","createdby":"Elmehdi Ouachmi","updatedby":"Elmehdi Ouachmi"},{"id":4,"name":"Avocado","description":null,"type":"Conventional","category":"Zutano","createdby":"Elmehdi Ouachmi","updatedby":"Elmehdi Ouachmi"},{"id":5,"name":"Avocado","description":null,"type":"Conventional","category":"Bacon","createdby":"Elmehdi Ouachmi","updatedby":"Elmehdi Ouachmi"},{"id":6,"name":"Avocado","description":null,"type":"Conventional","category":"Fuerte","createdby":"Elmehdi Ouachmi","updatedby":"Elmehdi Ouachmi"},{"id":17,"name":"Avocado","description":null,"type":"CAT2","category":"Hass","createdby":"Elmehdi Ouachmi","updatedby":"Elmehdi Ouachmi"},{"id":18,"name":"Avocado","description":"PALLET HASS OU LAMB HASS","type":"Conventional","category":"HASS OU LAMB HASS","createdby":"Elmehdi Ouachmi","updatedby":"Elmehdi Ouachmi"}]},{"id":15,"name":"Blueberry","description":null,"type":"Conventional","category":"Fresh","createdby":"Elmehdi Elmehdi","updatedby":"","subRows":[{"id":15,"name":"Blueberry","description":null,"type":"Conventional","category":"Fresh","createdby":"Elmehdi Ouachmi","updatedby":""},{"id":16,"name":"Blueberry","description":null,"type":"Standard","category":"IQF","createdby":"Elmehdi Ouachmi","updatedby":"Elmehdi Ouachmi"}]},{"id":8,"name":"Raspberry","description":null,"type":"Conventional","category":"Fresh","createdby":"Elmehdi Elmehdi","updatedby":"","subRows":[{"id":8,"name":"Raspberry","description":null,"type":"Conventional","category":"Fresh","createdby":"Elmehdi Ouachmi","updatedby":""},{"id":9,"name":"Raspberry","description":null,"type":"Whole","category":"IQF","createdby":"Elmehdi Ouachmi","updatedby":"Elmehdi Ouachmi"},{"id":10,"name":"Raspberry","description":null,"type":"Crumble","category":"IQF","createdby":"Elmehdi Ouachmi","updatedby":"Elmehdi Ouachmi"}]},{"id":11,"name":"Strawberry","description":null,"type":"Conventional","category":"Fresh","createdby":"Elmehdi Elmehdi","updatedby":"","subRows":[{"id":11,"name":"Strawberry","description":null,"type":"Conventional","category":"Fresh","createdby":"Elmehdi Ouachmi","updatedby":""},{"id":12,"name":"Strawberry","description":null,"type":"Whole","category":"IQF","createdby":"Elmehdi Ouachmi","updatedby":"Elmehdi Ouachmi"},{"id":13,"name":"Strawberry","description":null,"type":"Slice","category":"IQF","createdby":"Elmehdi Ouachmi","updatedby":"Elmehdi Ouachmi"},{"id":14,"name":"Strawberry","description":null,"type":"Cube","category":"IQF","createdby":"Elmehdi Ouachmi","updatedby":"Elmehdi Ouachmi"}]},{"id":7,"name":"Watermelon","description":null,"type":"Conventional","category":"Delta","createdby":"Elmehdi Elmehdi","updatedby":"","subRows":[{"id":7,"name":"Watermelon","description":null,"type":"Conventional","category":"Delta","createdby":"Elmehdi Ouachmi","updatedby":""}]}];
  // const table = useMaterialReactTable({
  //   columns,
  //   data,
  //   enableExpandAll: false, //hide expand all double arrow in column header
  //   enableExpanding: true,
  //   filterFromLeafRows: true, //apply filtering to all rows instead of just parent rows
  //   getSubRows: (row) => row.subRows, //default
  //   initialState: { expanded: true }, //expand all rows by default
  //   paginateExpandedRows: false, //When rows are expanded, do not count sub-rows as number of rows on the page towards pagination
  // });

  
 
  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />  
      {/* <ToastContainer /> */}

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Products</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Products</li>
                </ul>
              </div>
              <div className="col-auto">
              {permission && permission.add == 1 && (
                   <Link to="/products-add" className="btn btn-primary me-1">
                   <i className="fas fa-plus"></i>
                 </Link>
                )} 
               
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  {permission && permission.list == 1 && (
                  <div className="table-responsive">
                      <MaterialReactTable columns={columns2} data={dataa} 
                        enableColumnOrdering
                        enablePinning
                        // enableRowActions
                        // renderRowActionMenuItems={({ row }) => [
                        //   permission?.update == 1 && (
                        //     <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                        //       Edit
                        //     </MenuItem>
                        //   ),
                        //   permission?.delete == 1 && (
                        //     <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                        //       Delete
                        //     </MenuItem>
                        //   ),
                        // ]}
                    />                     
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Products;
